<template>
	<div class="group-account-selector" v-if="accounts.length > 0">
		<span class="selector-label">发送账号</span>
		<el-popover v-model="visible" placement="bottom-start" width="280" trigger="click" popper-class="group-account-popover">
			<div class="account-current" slot="reference" @click="loadAccounts()">
				<img v-if="current && current.avatar" :src="current.avatar" class="account-avatar" />
				<span class="account-name">{{ current ? (current.userName || current.identity) : '自动选择' }}</span>
				<i class="el-icon-arrow-down"></i>
			</div>
			<div class="account-options">
				<div v-for="acc in accounts" :key="acc.vid" class="account-option"
					:class="{ selected: current && acc.vid === current.vid }" @click="selectAccount(acc)">
					<img v-if="acc.avatar" :src="acc.avatar" class="account-avatar" />
					<span class="account-name">{{ acc.userName || acc.identity }}</span>
					<span class="account-identity">{{ acc.identity }}</span>
					<span class="account-status" :class="acc.login ? 'online' : 'offline'">{{ acc.login ? '在线' : '离线' }}</span>
					<i v-if="current && acc.vid === current.vid" class="el-icon-check"></i>
				</div>
			</div>
		</el-popover>
	</div>
</template>

<script>
import { getGroupAccounts, setGroupAccount } from "../../api/message.js";

export default {
	name: "GroupAccountSelector",
	props: {
		conversationID: {
			type: String,
			default: "",
		},
	},
	data() {
		return {
			accounts: [],
			current: null, // 当前发送账号（null=未指定，后端自动选号）
			visible: false,
		};
	},
	watch: {
		conversationID() {
			this.loadAccounts();
		},
	},
	mounted() {
		this.loadAccounts();
	},
	methods: {
		// 拉取群内我的账号列表；状态表记住的账号优先，否则不指定（自动选号）
		async loadAccounts() {
			if (!this.conversationID) {
				return;
			}
			const convID = this.conversationID; // 记录发起时的会话，防切换会话后旧响应覆盖（P3 修复）
			try {
				const list = await getGroupAccounts(convID);
				if (this.conversationID !== convID) {
					return; // 会话已切换，丢弃旧会话响应
				}
				this.accounts = list || [];
				const remembered = this.accounts.find(a => a.selected);
				this.current = remembered || null;
				this.$emit("change", this.current ? this.current.vid : "");
			} catch (e) {
				if (this.conversationID !== convID) {
					return; // 会话已切换，丢弃旧会话错误
				}
				// 错误提示由全局拦截器处理
				this.accounts = [];
				this.current = null;
			}
		},
		// 选择发送账号：调设置接口预切换（发送即切换由后端在发送时兜底同步）
		async selectAccount(acc) {
			try {
				await setGroupAccount({ conversationID: this.conversationID, vid: acc.vid });
				this.current = acc;
				this.accounts.forEach(a => {
					a.selected = a.vid === acc.vid;
				});
				this.visible = false;
				this.$emit("change", acc.vid);
			} catch (e) {
				// 错误提示由全局拦截器处理
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.group-account-selector {
	display: flex;
	align-items: center;
	padding: 4px 8px;
	border-bottom: 1px solid #eee;
	font-size: 13px;

	.selector-label {
		color: #999;
		margin-right: 8px;
	}

	.account-current {
		display: flex;
		align-items: center;
		cursor: pointer;
		padding: 2px 8px;
		border: 1px solid #e6e6e6;
		border-radius: 4px;
		background: #fafafa;

		&:hover {
			border-color: #409eff;
		}

		.account-name {
			margin: 0 4px;
			color: #333;
		}
	}

	.account-avatar {
		width: 20px;
		height: 20px;
		border-radius: 50%;
		object-fit: cover;
	}
}

.account-options {
	max-height: 260px;
	overflow-y: auto;

	.account-option {
		display: flex;
		align-items: center;
		padding: 8px 10px;
		cursor: pointer;
		border-radius: 4px;

		&:hover {
			background: #f0f4ff;
		}

		&.selected {
			background: #ecf3ff;
			color: #409eff;
		}

		.account-avatar {
			width: 28px;
			height: 28px;
			border-radius: 50%;
			object-fit: cover;
			margin-right: 8px;
		}

		.account-name {
			flex: 1;
			font-size: 14px;
		}

		.account-identity {
			color: #999;
			font-size: 12px;
			margin-right: 8px;
		}

		.account-status {
			font-size: 12px;

			&.online {
				color: #67c23a;
			}

			&.offline {
				color: #c0c4cc;
			}
		}

		.el-icon-check {
			margin-left: 8px;
			color: #409eff;
		}
	}
}
</style>
